/** Curated Google reviews – display names anonymized (first name + last initial). */

export const GOOGLE_REVIEWS_META = {
  rating: 5.0,
  totalCount: 100,
  totalLabel: '100+ értékelésből',
};

export const GOOGLE_REVIEWS = [
  {
    id: 'kornel-c',
    displayName: 'Kornél C.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: `Aposom 10 évet lakott itt! Összességében meg voltunk elégedve, voltak nehézségek főleg az elején, de azt gondolom, hogy 10 év távlatában azt kell, hogy mondjuk nagyon megérte.
Ami kifejezetten jó, hogy volt egy közösség, lehet több is, de egy amibe Aposom csatlakozott és nagyon kedves és értelmes idősek alkotják.

A hely maga gyönyörű és jól fel van szerelve. Az alkalmazottak kedvesek.`,
  },
  {
    id: 'sandor-sz',
    displayName: 'Sándor Sz.',
    relativeTime: '2 éve',
    text: `Sok felelőtlen, leépült, szájkaratézó aki modortalanságával, butaságával "hősködik" a sértő kifejezéseivel.
Velük ellentétben, ki merem jelenteni az otthonban igen magas szintű az ellátás. A dolgozók kedvesek, türelmesek, megértőek, segítőkészek – mindenben a lehető legtöbbet nyújtják.
Köztünk vannak rossztermészetű, közösségbe beilleszkedni nem tudó örök elégedetlenek, de ezek megfékezésében is rendkívül tapintatosak. Aki itt nem érzi jól magát, az keressen jobb helyet, nem kötelező itt lakni!
Köszönjük a dolgozók türelmét, segítőkészségét, figyelmességét. Ha javaslataink vannak közös foglalkozásokra, programokra, minden támogatást megadnak. Ha van ötleted, hogy mit szeretnél, azt mondd el, ne a dolgozókat sértegesd!
Aki pedig az étkezéssel elégedetlen, az járatlan a közétkeztetésben, mert nagyon is változatos és finom minden étel!
Az otthon minden dolgozójának köszönet a türelméért, kedvességéért, munkájáért! Tisztelettel – aki már több mint egy éve itt lakik, és jól érzi itt magát!`,
  },
  {
    id: 'marta-h',
    displayName: 'Márta H.',
    relativeTime: '2 éve',
    text: `Közel 3 éve él Édesanyánk a Napvirágban. Az Otthon neve is szimbolizálja azt az életkörülményt, amilyennek mindannyian érzékeljük a most már 90 éves édesanyánk lakóhelyét. A fizikai körülmények, az ott dolgozó munkatársak felkészültsége és szemlélete méltó az imádott édesanyához, nagymamához, dédnagymamához. A biztonságos, szakértő és emberi viszonyok jelentik a garanciát ahhoz, hogy az élet utolsó szakaszában is teljes értékű életet élhessen. Köszönet a Csapatnak ezért!`,
  },
  {
    id: 'ferenc-t',
    displayName: 'Ferenc T.',
    relativeTime: '2 éve',
    isLocalGuide: true,
    text: `Szerintem és édesanyám visszajelzése alapján a Napvirág Otthon kiemelkedik a legtöbb, környéken lévő idősek otthona közül, és nagyon szép környezetben és jó minőségű apartmanokban lehet itt lakni. Véleményem szerint ez az otthon nagyon jó ár/érték arányban van, és a személyzet is mindent megtesz az itt lakók közérzetéért, egészségügyi ellátásáért. Csak ajánlani tudom.`,
  },
  {
    id: 'agi-z',
    displayName: 'Ági Z.',
    relativeTime: '2 éve',
    isLocalGuide: true,
    text: 'Kitűnő intézmény. Kedves, udvarias személyzet, mindenhol tisztaság van. Rengeteg program, műsorok, foglalkozások szórakoztatják az időseket. Apukám is elégedett az ellátással. Csak ajánlani tudom!',
  },
  {
    id: 'seta-b',
    displayName: 'Séta B.',
    relativeTime: '10 éve',
    isLocalGuide: true,
    text: `A Napvirág Idősek Otthona modern, négyszintes épületben működik 2006 februárjától. Az épületben 121 akadálymentes, kényelmesen, otthonosan berendezhető, napfényes apartman mellett számos olyan helység található, amely lakóink jó közérzetét biztosítja: tágas étterem, modern, jól felszerelt konyhával, ahol a napi ötszöri étkezést biztosítják. Az ételeket a könnyű vegyes étrend összeállításának szabályai határozzák meg, de nagy számban készül diabéteszes valamint epe- és májkímélő diéta is.`,
  },
  {
    id: 'zombie-p',
    displayName: 'Z. P.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: 'Az intézmény csodálatos helyen fekszik Budakalász peremén, tiszta levegővel, madárcsicsergéssel. Az itt dolgozók lelkesen segítik az itt élő idősek mindennapjait. Jók az ételek, változatos konyha. Csak ajánlani lehet!',
  },
  {
    id: 'eva-c',
    displayName: 'Eva C.',
    relativeTime: '5 hónapja',
    text: 'Szerintem ez a hely pont úgy jó, ahogy van. Az ételek változatosak és háziasak.',
  },
  {
    id: 'anna-h',
    displayName: 'Anna H.',
    relativeTime: '2 éve',
    text: 'Kellemes környezet, kedves személyzet, korrekt ellátás.',
  },
  {
    id: 'gabor-p',
    displayName: 'Gábor P.',
    relativeTime: '2 napja',
    isLocalGuide: true,
    text: 'Minden igényt kielégít.',
  },
  {
    id: 'zsuzsa-sz',
    displayName: 'Zsuzsa Sz.',
    relativeTime: '3 hete',
    isLocalGuide: true,
    text: 'Könnyen megközelíthető, van parkoló.',
  },
  {
    id: 'zoltan-n',
    displayName: 'Zoltán N.',
    relativeTime: '2 hete',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'balazs-b',
    displayName: 'Balázs B.',
    relativeTime: '3 hete',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'balazs-z',
    displayName: 'Balázs Z.',
    relativeTime: '9 hónapja',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'zoltanne-h',
    displayName: 'Zoltánné H.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'bence-n',
    displayName: 'Bence N.',
    relativeTime: '1 éve',
    text: '',
  },
  {
    id: 'klon-d',
    displayName: 'Klón D.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'peter-u',
    displayName: 'Peter U.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'lajbi-i',
    displayName: 'Lajbi I.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'miki-t',
    displayName: 'Miki T.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'krisztian-s',
    displayName: 'Krisztián S.',
    relativeTime: '2 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'marcsi-g',
    displayName: 'Marcsi G.',
    relativeTime: '2 éve',
    text: '',
  },
  {
    id: 'judit-b',
    displayName: 'Judit B.',
    relativeTime: '2 éve',
    text: '',
  },
  {
    id: 'balazs-m',
    displayName: 'Balázs M.',
    relativeTime: '2 éve',
    text: '',
  },
  {
    id: 'istvan-b',
    displayName: 'István B.',
    relativeTime: '2 éve',
    text: '',
  },
  {
    id: 'zsofi-m',
    displayName: 'Zsófi M.',
    relativeTime: '2 éve',
    text: '',
  },
  {
    id: 'tivadar-a',
    displayName: 'Tivadar A.',
    relativeTime: '2 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'akos-p',
    displayName: 'Ákos P.',
    relativeTime: '2 éve',
    text: '',
  },
  {
    id: 'krisztina-v',
    displayName: 'Krisztina V.',
    relativeTime: '2 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'jozsef-z',
    displayName: 'József Z.',
    relativeTime: '6 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'bence-u',
    displayName: 'Bence U.',
    relativeTime: '7 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'l-t',
    displayName: 'L. T.',
    relativeTime: '8 éve',
    text: '',
  },
  {
    id: 'rita-k',
    displayName: 'Rita K.',
    relativeTime: '8 éve',
    isLocalGuide: true,
    text: '',
  },
  {
    id: 'balint-d',
    displayName: 'Bálint D.',
    relativeTime: '1 éve',
    isLocalGuide: true,
    text: '',
  },
];

export const EMPTY_REVIEW_TEXT = 'Ötcsillagos értékelés a Google-on.';

export const REVIEW_TEXT_CLAMP = 220;
